import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=5a42fb47&"
import script from "./PriceInput.vue?vue&type=script&lang=ts&"
export * from "./PriceInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports